import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    LandingPageRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    LegacySignupRoute: {
        to: "/signup-legacy",
        build: (options) => interpolatePath("/signup-legacy", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminRoute: {
        to: "/admin",
        build: (options) => interpolatePath("/admin", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminOnboardingRoute: {
        to: "/admin/onboarding",
        build: (options) => interpolatePath("/admin/onboarding", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminOptimizationDashboardRoute: {
        to: "/admin/optimization/dashboard",
        build: (options) => interpolatePath("/admin/optimization/dashboard", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminOptimizationTestingRoute: {
        to: "/admin/optimization/testing",
        build: (options) => interpolatePath("/admin/optimization/testing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminGengageSettingsRoute: {
        to: "/admin/gengage-settings",
        build: (options) => interpolatePath("/admin/gengage-settings", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminDashboardRoute: {
        to: "/admin/dashboard",
        build: (options) => interpolatePath("/admin/dashboard", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminProductsPageRoute: {
        to: "/admin/products",
        build: (options) => interpolatePath("/admin/products", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminJobsPageRoute: {
        to: "/admin/jobs",
        build: (options) => interpolatePath("/admin/jobs", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminEnrichmentConfigPageRoute: {
        to: "/admin/generate-and-enhance",
        build: (options) => interpolatePath("/admin/generate-and-enhance", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminDebugRoute: {
        to: "/admin/debug",
        build: (options) => interpolatePath("/admin/debug", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminUsersCollectionsRoute: {
        to: "/admin/users-collections",
        build: (options) => interpolatePath("/admin/users-collections", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminUsageRoute: {
        to: "/admin/usage",
        build: (options) => interpolatePath("/admin/usage", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminBillingRoute: {
        to: "/admin/billing",
        build: (options) => interpolatePath("/admin/billing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminUpgradePlanRoute: {
        to: "/admin/upgrade-plan",
        build: (options) => interpolatePath("/admin/upgrade-plan", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    NotFoundRoute: {
        to: "*",
        build: (options) => interpolatePath("*", options.params, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    BillinTestRoute: {
        to: "/admin/asl16dxcvyhfmasklf234",
        build: (options) => interpolatePath("/admin/asl16dxcvyhfmasklf234", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AuthSucceededRoute: {
        to: "/auth/redirect",
        build: (options) => interpolatePath("/auth/redirect", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map